import { Box, Button, SxProps, Theme, useTheme } from '@mui/material'
import { useState } from 'react'

import UpgradeToUnlock from '~/components/upgradeToUnlock'
import useUserAccess from '~/features/auth/hooks/useUserAccess'

type TProps = {
  children: React.ReactNode
  wrapperSx?: SxProps<Theme>
  shouldBelongToPlusPlan?: boolean
  shouldShowOverlay?: boolean
  availableForBasicFreeTrial?: boolean
  isMarkingPaidFeature?: boolean
}

function UpgradeWrapper({
  children,
  wrapperSx = {},
  shouldBelongToPlusPlan = false,
  shouldShowOverlay = true,
  availableForBasicFreeTrial = true,
  isMarkingPaidFeature = false,
}: TProps) {
  const theme = useTheme()
  const [showUpgradeToUnlock, setShowUpgradeToUnlock] = useState(false)

  const { isBasicFreeTrial, isBasicUser, isPlusUser } = useUserAccess()

  const isPaidUser = isBasicUser || isPlusUser

  if (
    isPlusUser ||
    (isPaidUser && !isBasicFreeTrial && !isPlusUser && !shouldBelongToPlusPlan)
  ) {
    return children
  }

  const paidFeatureStyles = {
    backgroundColor: theme.palette.mainBackground,
  }
  const updateStyles = {
    cursor: 'not-allowed',
    backgroundColor: theme.palette.mainBackground,
  }

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: { xxxs: 'center', xs: 'flex-start' },
          gap: 4,
          flexWrap: 'wrap',
          paddingTop: 0,
          padding: 2,
          paddingBottom: { xxxs: 3, sm: 2 },
          '&.MuiBox-root': {
            width: { xxxs: '100%', md: 'fit-content' },
          },
          '& .MuiFormLabel-root': {
            whiteSpace: 'normal',
          },
          ...(isBasicFreeTrial && availableForBasicFreeTrial
            ? paidFeatureStyles
            : updateStyles),
          ...wrapperSx,
        }}
      >
        <Box
          sx={{
            pointerEvents:
              isBasicFreeTrial && availableForBasicFreeTrial ? 'auto' : 'none',
            position: 'relative',
            display: 'flex',
            '& .MuiBox-root': {
              opacity:
                (shouldShowOverlay && !isBasicFreeTrial) ||
                (shouldShowOverlay &&
                  isBasicFreeTrial &&
                  !availableForBasicFreeTrial)
                  ? 0.5
                  : 1,
            },
          }}
        >
          {shouldShowOverlay && !isBasicFreeTrial && (
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
              }}
            />
          )}
          {children}
        </Box>
        <Box
          display="flex"
          alignItems="flex-end"
          justifyContent="flex-end"
          flex="1"
        >
          <Button
            variant="primary"
            onClick={() => setShowUpgradeToUnlock(true)}
          >
            {(isBasicFreeTrial && availableForBasicFreeTrial) ||
            isMarkingPaidFeature
              ? 'Paid feature'
              : 'Upgrade'}
          </Button>
        </Box>
      </Box>
      <UpgradeToUnlock
        isOpen={showUpgradeToUnlock}
        onClose={() => setShowUpgradeToUnlock(false)}
      />
    </>
  )
}

export default UpgradeWrapper
